import { useMutation, useQueryClient } from '@tanstack/react-query';
import fetchClient from '@eureca/recruiter-api-sdk/client';
import type { PostJobs201, PostJobsMutationRequest } from '@eureca/recruiter-api-sdk/types';

export class JobMutationError extends Error {
  readonly name = 'JobMutationError';
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

/**
 * Mutation for `POST /jobs`. On success invalidates the jobs list so a
 * refetch picks up the new draft. The container is responsible for navigating
 * to `/vagas/nova/sucesso` (or wherever) on its own.
 */
export function usePostJob() {
  const queryClient = useQueryClient();
  return useMutation({
    // DEV-509 — sem rede, falhar (e mostrar o erro) em vez de pausar o "Criar vaga".
    networkMode: 'always',
    mutationFn: async (body: PostJobsMutationRequest): Promise<PostJobs201> => {
      const res = await fetchClient<PostJobs201>({
        method: 'POST',
        url: '/jobs',
        data: body,
      });
      if (res.error) {
        throw new JobMutationError(
          `Failed to create job (status ${res.error.status})`,
          res.error.status
        );
      }
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['recruiter', 'jobs'] });
    },
  });
}
